import type { QueryParamsDto } from "@mimber/schema"

/**
 * Query key utilities for households hooks (org admin)
 * Keys match backend controller method names
 */
export const householdsKeys = {
  findAll: (params?: QueryParamsDto) =>
    params
      ? (["households", "findAll", params] as const)
      : (["households", "findAll"] as const),
  findOne: (uuid: string) => ["households", "findOne", uuid] as const,
} as const
